import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "minutesLimit", "navigation", "questionOrder",
                     "examTitle",
                     "administrationYear", "minRosteringsCount", "blackBackground",
                     "examCourse", "examForm", "examVersion",
                     "detectionNotice"]

  initialize() {
    this.generateTitle()
    this.updateDetectionNotice()
  }

  availableVersions() {
    let url = this.examVersionTarget.dataset.url && new URL(this.examVersionTarget.dataset.url)

    let required_fields_completed =
    this.navigationTarget.value         != "" &&
    this.questionOrderTarget.value      != "" &&
    this.administrationYearTarget.value != "" &&
    this.minutesLimitTarget.value       != ""

    if (url && required_fields_completed) {
      // Exam Params
      url.searchParams.append('minutes_limit',       this.minutesLimitTarget.value)
      url.searchParams.append('navigation',          this.navigationTarget.value)
      url.searchParams.append('question_order',      this.questionOrderTarget.value)
      url.searchParams.append('administration_year', this.administrationYearTarget.value)
      url.searchParams.append('black_background',    this.blackBackgroundTarget.checked)
      url.searchParams.append('form',                this.examFormTarget.value)
      url.searchParams.append('title',               this.examTitleTarget.value)
      url.searchParams.append('version',             this.examVersionTarget.value)

      fetch(url)
        .then(response => response.text())
        .then(html => {
          document.getElementById("version-select").innerHTML = html
          this.generateTitle()
        })
    }
  }

  generateTitle() {
    let url = this.administrationYearTarget.dataset.url && new URL(this.administrationYearTarget.dataset.url)

    if (url) {
      url.searchParams.append('administration_year', this.administrationYearTarget.value)
      url.searchParams.append('form', this.examFormTarget.value)
      url.searchParams.append('version', this.examVersionTarget.value)
    }

    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.examTitleTarget.outerHTML = html
      })
  }

  updateDetectionNotice() {
    let url = this.detectionNoticeTarget.dataset.url && new URL(this.detectionNoticeTarget.dataset.url)

    if (url) {
      url.searchParams.append('administration_year', this.administrationYearTarget.value)
    }

    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.detectionNoticeTarget.innerHTML = html
      })
  }

  submit(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const form = this.element
    const url = form.dataset.questionCheckUrl

    $.ajax({
      url: url,
      type: "GET",
      data: { question_ids: this.selectedQuestionIds(form) },
      dataType: "json",
      success: (response) => {
        if (response.status === 'ok') {
          this.continueSubmission();
        } else if (response.status === 'unprocessable_entity') {
          this.showWarningModal(response.html);
        }
      },
    });
  }

  selectedQuestionIds(form) {
    return Array.from(form.querySelectorAll('input[name^="assessment_exam_variation[questions]"][name$="[question_id]"]'))
      .filter((input) => {
        const row = input.closest('tr')
        const selectedInput = row?.querySelector('input[name^="assessment_exam_variation[questions]"][name$="[selected]"]')

        return selectedInput?.value === 'true'
      })
      .map(input => input.value)
  }

  continueSubmission() {
    const form = this.element;
    form.submit();
  }

  showWarningModal(htmlContent) {
    document.getElementById('warning-modal-container').innerHTML = htmlContent;
  }

  preventEnterSubmit(event) {
    if (event.target.matches('input:not([type="submit"]):not([type="button"])')) {
      event.preventDefault()
    }
  }
}
